import Header from "../../components/header";
import { Container, HeaderSection, ListContainer } from "../style";
import CreateBoardModal from "../../components/modals/createBoardModal";
import UserInfoCard from "../../components/dashboardSections/userInfoCard";
import { CircularProgress, Stack, Grid } from "@mui/material";
import DownloadExtensionCard from "../../components/dashboardSections/downloadExtensionCard";
import SwipeAdSection from "../../components/dashboardSections/swipeAdSection";
import ExploreLoungeSection from "../../components/dashboardSections/exploreLoungeSection";
import TranscriptLoungeSection from "../../components/dashboardSections/transcriptSection";
import LearnSwipeLoungeSection from "../../components/dashboardSections/learnSwipeLoungeSection";
import ContactUsSection from "../../components/dashboardSections/contactUsSection";
import { useSelector } from "react-redux";
import {
  DashoardAnalyticsSaga,
  DashoardAnalyticsSagaName,
} from "../../store/dashboardAnalytics/sagas";
import {
  DashoardAnalyticsReducer,
  DashoardAnalyticsReducerName,
} from "../../store/dashboardAnalytics/slice";
import {dashboardAnalyticsSelector, dashboardLoadingSelector} from "../../store/dashboardAnalytics/selector";
import OpenViewFolderModal from "../../components/modals/openViewFolderModal";
import CreateTeamModal from "../../components/modals/createTeamModal";
import SubscriptionPlansSection from "../../components/dashboardSections/subscriptionPlansSection";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import {userDetailsSelector} from "../../store/account/selector";

const content = {
  tabTitle: "Dashboard",
  tabSubTitle: "Your Creative Strategy Hub",
};

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = useSelector(userDetailsSelector);
  const dashboardLoading = useSelector(dashboardLoadingSelector);
  useInjectReducer({
    reducer: DashoardAnalyticsReducer,
    key: DashoardAnalyticsReducerName,
  });

  useInjectSaga({
    saga: DashoardAnalyticsSaga,
    key: DashoardAnalyticsSagaName,
  });

  const dashboardAnalytics = useSelector(dashboardAnalyticsSelector);

  useEffect(() => {
    const shouldScroll = location.state?.scrollToContactUs;
    if (shouldScroll && dashboardAnalytics?.userActivePlan?.name) {
      const tryScroll = () => {
        const contactEle = document.querySelector(".contact-us-container");
        if (contactEle) {
          contactEle.scrollIntoView({ behavior: "smooth" });

          const contactNameEle = document.querySelector(
            ".contact-form-name input"
          ) as HTMLInputElement;
          contactNameEle?.focus();

          navigate(location.pathname, { replace: true, state: {} });

          return true;
        }
        return false;
      };

      const interval = setInterval(() => {
        const success = tryScroll();
        if (success) clearInterval(interval);
      }, 200);

      setTimeout(() => clearInterval(interval), 5000);
    }
  }, [location.state?.scrollToContactUs, dashboardAnalytics]);

  return (
    <Container>
      <HeaderSection>
        <Header content={content} />
        <ListContainer display={"flex"} flexDirection={"column"} gap="1.875rem">
          {!userDetails || dashboardLoading  ? (
            <CircularProgress sx={{ placeSelf: "center" }} />
          ) : (
            <>
              <Stack direction="row" gap="1.875rem">
                <UserInfoCard />
                <DownloadExtensionCard />
              </Stack>
              <Grid container spacing={"1.875rem"}>
                <Grid
                  item
                  sm={6}
                  sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
                >
                  <SubscriptionPlansSection />
                </Grid>
                <Grid
                  item
                  sm={6}
                  sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
                >
                  <LearnSwipeLoungeSection />
                </Grid>
              </Grid>
              <SwipeAdSection />
              <ExploreLoungeSection />
              <Stack
                className="contact-us-container"
                direction="row"
                gap="1.875rem"
              >
                <TranscriptLoungeSection />
                <ContactUsSection />
              </Stack>
            </>
          )}
        </ListContainer>
      </HeaderSection>
      <CreateBoardModal />
      <OpenViewFolderModal />
      <CreateTeamModal />
    </Container>
  );
};

export default Dashboard;
